var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('fa-icon',_vm._b({staticClass:"mr-2",attrs:{"icon":_vm.icon,"size":"sm"}},'fa-icon',_vm.$attrs,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }